@if (isMobileViewport()) {
  <cdk-accordion-item
    #accordionItem="cdkAccordionItem"
    role="button"
    tabindex="0"
    [attr.id]="'accordion-header'"
    [attr.aria-expanded]="accordionItem.expanded"
    [attr.aria-controls]="'accordion-body'"
  >
    <div (click)="accordionItem.toggle()">
      {{ text() }}
      <span class="sr-only">
        Click to {{ accordionItem.expanded ? "close" : "open" }}
      </span>
      <svg
        class="w-2.5 h-2.5 ms-1 inline"
        [ngClass]="{ 'rotate-180': accordionItem.expanded }"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 10 6"
      >
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="m1 1 4 4 4-4"
        />
      </svg>
    </div>
    <div
      role="region"
      [style.display]="accordionItem.expanded ? '' : 'none'"
      [attr.id]="'accordion-body'"
      [attr.aria-labelledby]="'accordion-header'"
      class="border-l border-solid border-l-primary-500 mt-4"
    >
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </div>
  </cdk-accordion-item>
} @else {
  <button [matMenuTriggerFor]="menu">
    {{ text() }}
    <svg
      class="w-2.5 h-2.5 ms-1 inline"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 10 6"
    >
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="m1 1 4 4 4-4"
      />
    </svg>
  </button>
  <mat-menu #menu="matMenu" yPosition="below">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </mat-menu>
}
<ng-template #content>
  <ng-content></ng-content>
</ng-template>
